module.exports = __webpack_public_path__ + "static/media/rate.dbe2cedb.svg";